import React from "react";
import ScheduleSelectorTitle from "./Components/ScheduleSelectorTitle/ScheduleSelectorTitle";
import GetScheduleComponent from "./Components/GetScheduleComponent";
import { IScheduleSelectorProps } from "./ScheduleSelector";
import { useHideScheduleSelector } from "./useHideScheduleSelector";

const ScheduleSelector = (
    props: IScheduleSelectorProps
): JSX.Element | null => {
    const hideComponent = useHideScheduleSelector();

    if (hideComponent) return null;

    return (
        <>
            <ScheduleSelectorTitle {...props} />
            <GetScheduleComponent {...props} />
        </>
    );
};

export default ScheduleSelector;
